import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { StorageClientContext } from "./generated/src/storageClientContext";
import { escapeURLPath, getURLScheme, iEqual, getAccountNameFromUrl } from "./utils/utils.common";
import { AnonymousCredential } from "./credentials/AnonymousCredential";
import { StorageSharedKeyCredential } from "./credentials/StorageSharedKeyCredential";
import { isTokenCredential, isNode } from "@azure/core-http";
/**
 * A StorageClient represents a based URL class for {@link BlobServiceClient}, {@link ContainerClient}
 * and etc.
 */

export var StorageClient =
/**
 * Creates an instance of StorageClient.
 * @param url - url to resource
 * @param pipeline - request policy pipeline.
 */
function StorageClient(url, pipeline) {
  _classCallCheck(this, StorageClient);

  // URL should be encoded and only once, protocol layer shouldn't encode URL again
  this.url = escapeURLPath(url);
  this.accountName = getAccountNameFromUrl(url);
  this.pipeline = pipeline;
  this.storageClientContext = new StorageClientContext(this.url, pipeline.toServiceClientOptions());
  this.isHttps = iEqual(getURLScheme(this.url) || "", "https");
  this.credential = new AnonymousCredential();

  var _iterator = _createForOfIteratorHelper(this.pipeline.factories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var factory = _step.value;

      if (isNode && factory instanceof StorageSharedKeyCredential || factory instanceof AnonymousCredential) {
        this.credential = factory;
      } else if (isTokenCredential(factory.credential)) {
        // Only works if the factory has been attached a "credential" property.
        // We do that in newPipeline() when using TokenCredential.
        this.credential = factory.credential;
      }
    } // Override protocol layer's default content-type

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var storageClientContext = this.storageClientContext;
  storageClientContext.requestContentType = undefined;
};